module.exports = __webpack_public_path__ + "static/media/inventory.b8126e64.png";